<template lang="html">
  <div>
    <div class="label subtype node-move">
      <select v-model="node.subtype">
        <option value="random">Random</option>
        <option value="condition">Condition</option>
      </select>
      <button type="button" class="btn-flat btn-icon" @click="addChoice()"><i class="icon-add"></i></button>
    </div>
    <div v-for="(choice, index) in node.choices" :key="index" class="node-choice">
      <input v-if="node.subtype === 'condition'" type="text" v-model="choice.condition" placeholder="condition" class="form-input" />
      <div v-if="node.subtype === 'random'" class="input-group" style="width: 100%;">
        <input type="number" v-model="choice.weight" placeholder="weight" min="1" class="form-input" />
        <span class="chance input-group-append">{{Math.round(calcChance(choice) * 100)}}%</span>
      </div>
      <button type="button" class="btn-flat btn-icon" @click="removeChoice(index)"><i class="icon-delete"></i></button>
      <div class="node-connector" :class="{'active': choice.to}" :data-index="index" :data-to="choice.to"></div>
    </div>
  </div>
</template>

<script>
export default {
	props: ['node'],
	methods: {
    addChoice() {
      this.node.choices.push({
        condition: '',
        weight: '1',
        to: null
      });
    },
    removeChoice(index) {
      this.node.choices.splice(index, 1);
    },
    calcChance(choice) {
      const total = this.node.choices.map(x => parseFloat(x.weight)).reduce((a, b) => a + b, 0);
      return total ? choice.weight/total : 0;
    }
	}
}
</script>

<style lang="css" scoped>
.node-choice {
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}
.node-choice input {
  font-family: monospace;
  border: none;
}
.node-choice button {
  margin: 0 2px;
  padding: 3px;
}
.node-choice .node-connector {
  margin-left: 2px;
  margin-right: -9px;
  border-radius: 50%;
  border: 3px solid #34434b;
  width: 18px;
  height: 18px;
  flex: 0 0 auto;
  background-color: #1f282d;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  /* border-left-color: transparent; */
  /* border-top-color: transparent; */
  transform: rotate(-45deg);
}
.node-choice .node-connector.active::before {
  content: '';
  position: absolute;
  background-color: #ffa800;
  border-radius: 50%;
  inset: 1px;
}
.node-box.selected .node-choice .node-connector {
  border-right-color: rgba(255, 168, 0, 0.8);
  border-bottom-color: rgba(255, 168, 0, 0.8);
}
.node-box .subtype {
  padding: 0 10px 0 0 !important;
}
.node-box .subtype select {
  border: none;
}
.input-group {
  border: none;
}
.chance {
  font-size: 14px;
}
</style>
